<template>
  <v-app class="body" >
    <v-app-bar app flat max-height="65"  class="mr-0 ml-0 pl-12 pr-0" >
    
      <Header />
    </v-app-bar>
    <router-view class="body" ></router-view>
    <v-footer>
      <Footer />
    </v-footer>
  </v-app>
</template>
<script>
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";

export default {
  name: "App",

  components: {
    Header,
    Footer
  },

  data: () => ({
    //
  })
};
</script>

<style scoped>
  body {
  background: url(coffee-apple.jpg) no-repeat center center fixed;
  -webkit-background: cover;
  -moz-background: cover;
  -o-background: cover;
  background: cover;
}

</style>
